import { useEffect, useState } from "react";
import CalendarV2 from "../../calendar-v2/CalendarV2";

export default function DayDiary({ initialDate = null, onOpenLesson = null, onCreateSlot = null, onDataChanged = null, className = "" }) {
  const [calendarRevision, setCalendarRevision] = useState(0);

  useEffect(() => {
    const refresh = () => setCalendarRevision((revision) => revision + 1);
    window.addEventListener("ndg:diary-refresh", refresh);
    return () => window.removeEventListener("ndg:diary-refresh", refresh);
  }, []);

  return (
    <div className={className} data-testid="day-diary-calendar-v2">
      <CalendarV2
        key={calendarRevision}
        initialDate={initialDate || undefined}
        onAssign={({ date, space }) => onCreateSlot?.(date, space.start, 120)}
        onOpenBooking={({ date, space }) => onOpenLesson?.({
          id: space.booking_id,
          date,
          pupil_id: space.pupil_id,
          pupil_user_id: space.pupil_user_id,
          student_id: space.student_id,
          title: space.pupil_name,
          start_time: space.start,
          end_time: space.end,
          booking_purpose: space.booking_purpose || "lesson",
          early_arrival_minutes: space.early_arrival_minutes || 10,
          _source: "calendar_v2",
        })}
        onSlotChange={() => onDataChanged?.()}
      />
    </div>
  );
}

